import Vue from "vue";
import store from "@/store";
import html2canvas from "html2canvas";
import { actionType } from "./action-type.js";
import { getRoute, isAPP, getPlatform, isUrl } from "@environment/type";
import { typeName as vueTypeName } from "@environment/type/vue-until"; //vue 环境方法
import { openAction } from "@environment/model/remould-router";
import router from "../../router";

export const commonAction = (actionName, param) => {
  let platform = getPlatform();

  if (actionName == "routerPush" || actionName == "routerReplace") {
    param.path = getRoute(true) + "/" + param.path;
  }
  // console.log(window.location.href);
  // console.log(isAPP());
  !param && (param = { isNodata: true });
  let stringParam = JSON.stringify(param);
  //console.log("方法名称=" + actionName + "字符串=" + stringParam);
  try {
    // 特殊处理showNotify,hideLoading,showLoading后改为执行vue环境的方法
    switch (actionName) {
      case "setAlias":
        vueTypeName.setAlias(param);
        break;
      case "onClearBadge":
        vueTypeName.onClearBadge(param);
        break;
      case "initJpush":
        vueTypeName.initJpush(param);
        break;
      case "showNotify":
        vueTypeName.showNotify(param);
        break;
      case "hideNotify":
        vueTypeName.hideNotify(param);
        break;
      case "showDialog":
        vueTypeName.showDialog(param);
        break;
      case "hideDialog":
        vueTypeName.hideDialog(param);
        break;
      case "showToast":
        vueTypeName.showToast(param);
        break;
      case "hideToast":
        vueTypeName.hideToast(param);
        break;
      case "showLoading":
        vueTypeName.showLoading(param);
        break;
      case "hideLoading":
        vueTypeName.hideLoading(param);
        break;
      case "pop":
        vueTypeName.pop(param);
        break;
      case "routerPush":
        vueTypeName.routerPush(param);
        break;
      case "routerReplace":
        vueTypeName.routerReplace(param);
        break;
      case "picturePreview":
        vueTypeName.picturePreview(param);
        break;
      case "downloadImage": {
        if (isAPP()) {
          Base64Image.save(param.element.src, () => {
            vueTypeName.showDialog({
              msg: param.successText
            });
          }, (err) => {
            vueTypeName.showDialog({
              msg: param.failText + " ( " + err + " ) "
            });
          });
        } else {
          html2canvas(param.element, {
            allowTaint: true,
            useCORS: true, // 设置跨域
            tainttest: true, // 检测每张图片都已经加载完成
            backgroundColor: null, // 背景色, 转换图片可能会有白色底色，不要的话就null
          }).then((canvas) => {
            var link = document.createElement("a"); // 创建一个超链接对象实例
            link.download = "download.png"; // 设置要下载的图片的名称
            link.href = canvas.toDataURL(); // 将图片的URL设置到超链接的href中
            link.click(); // 触发超链接的点击事件
          });
        }
        break;
      }
      case "refresh":
        //更新水印
        if (store.getters.isLogging) {
          var content = "";
          var userInfo = JSON.parse(localStorage.getItem("auth")).userInfo;
          if (userInfo.UserId) {
            content = userInfo.CompanyCode + " " + userInfo.UserName;
          }
          if (userInfo.CustomerId) {
            content = userInfo.CompanyName;
          }
          Vue.prototype.$watermark.changeOptions({
            content: content,
            width: 200,
            height: 200,
            zIndex: -1,
            rotate: 30,
            fontSize: "14px",
            fontColor: "#e5e5e5",
          });
        }
        if (isAPP()) {
          window.plugins.webViewReloader.reload();
        } else {
          location.reload();
        }
        break;
      case "backHome":
        vueTypeName.backHome(param);
        break;
      case "backUser":
        vueTypeName.backUser(param);
        break;
      case "clickCopy": {
        if (isAPP()) {
          window.cordova.plugins.clipboard.copy(param.text);
          vueTypeName.showNotify({
            type: "success",
            titleMsg: param.alertText
          });
        } else {
          Vue.prototype.$copyText(param.text).then(() => {
            vueTypeName.showNotify({
              type: "success",
              titleMsg: param.alertText
            });
          });
        }
        break;
      }
      case "gotoPay": {
        if (isAPP()) {
          window.cordova.InAppBrowser.open(param.url, '_system');
        } else {
          window.location.href = param.url;
        }
        break;
      }
      case "scan": {
        if (isAPP()) {
          window.cordova.plugins.gizscanqrcode.scan(param.options, (res) => {
            var data = JSON.parse(res);
            if (data.result) {
              if (isUrl(data.result)) {
                window.cordova.InAppBrowser.open(data.result, '_system');
              } else {
                vueTypeName.showDialog({
                  msg: data.result
                });
              }
            }
          }, (err) => {
            var data = JSON.parse(err);
            if (data.resultCode == 2) {
              vueTypeName.showDialog({
                msg: param.errorText
              });
            }
            if (data.resultCode == 4) {
              vueTypeName.showDialog({
                msg: param.authText
              });
            }
          });
        } else {
          openAction();
        }
        break;
      }
      case "scanToPage": {
        if (isAPP()) {
          window.cordova.plugins.gizscanqrcode.scan(param.options, (res) => {
            var data = JSON.parse(res);
            if (data.result) {
              router.replace({
                name: param.path,
                path: param.path,
                query: { SearchText: data.result }
              })
              //window.location.replace(param.path + '?SearchText=' + data.result);
            }
          }, (err) => {
            var data = JSON.parse(err);
            if (data.resultCode == 2) {
              vueTypeName.showDialog({
                msg: param.errorText
              });
            }
            if (data.resultCode == 4) {
              vueTypeName.showDialog({
                msg: param.authText
              });
            }
          });
        } else {
          openAction();
        }
        break;
      }
      case "exitapp": {
        if (isAPP()) {
          navigator.app.exitApp();
        } else {
          openAction();
        }
        break;
      }
      default: {
        if (platform == 'ios') {
          navigator[actionName](stringParam);
        } else {
          window.controller[actionName](stringParam);
        }
      }
    }
  } catch (error) {
    console.log("ios或android环境没有匹配搭配方法名称" + actionName);
  }
};

export const envType = query => {
  const login = {
    userName: null,
    token: query.token
  };
  query.token && localStorage.setItem("auth", JSON.stringify(login));
  // 设置多语言
  // query.language && localStorage.setItem("language", query.language);
};
Vue.prototype.$commonEnv = {
  commonAction,
  actionType
  // env
};
export default {
  commonAction,
  envType
};
